import { useQuery } from 'react-query';
import { albumResponse } from 'src/models/gallery';
import { fetchAlbums } from 'src/services/gallery';

export default function useListAlbums() {
  return useQuery<albumResponse[]>(['albums'], () => fetchAlbums());
}
